import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ClientCreate" }
const _hoisted_2 = { class: "ClientCreate__name" }
const _hoisted_3 = { class: "ClientCreate__tools" }

import { ref } from "vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { clientToSlug } from "@/tools/client";
import { useRouter } from "vue-router";
import { useClientStore } from "@/stores/clients";
import api from "@/api";
import InnInput from "@/components/ds/input/Input.vue";
import { useCompanyStore } from "@/stores/company";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientCreate',
  setup(__props) {

const clientsStore = useClientStore();
const router = useRouter();
const name = ref("");
const companyStore = useCompanyStore();

const createClient = () => {
    const client = clientsStore.getNew();
    client.name = name.value;
    api.create(client, "clients").then((response) => {
        client.id = response.id;
        if (companyStore.company) {
            client.rate = companyStore.company.standardRate;
        }

        clientsStore.create(client);
        const slug = clientToSlug(client, -1);
        router.push({ name: "Client", params: { slug } });
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InnInput, {
        modelValue: name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
        placeholder: "Naam van klant..."
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(IconButton, {
        disabled: name.value.length === 0,
        "icon-id": "plus",
        onClick: createClient
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Klant aanmaken ")
        ])),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})